module.exports = __webpack_public_path__ + "media/Video 16.4cf68392.mp4";